import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col h-fit rounded-b-lg relative overflow-y-auto border bg-gray-lp-200 border-gray-lp-400 text-black-lp-300 gap-y-6 text-12px xxl:text-14px font-montserrat" }
const _hoisted_2 = { class: "flex items-center w-full text-14px flex-nowrap" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center flex-nowrap"
}
const _hoisted_4 = { class: "truncate font-semibold" }
const _hoisted_5 = { class: "mx-1 font-medium whitespace-nowrap flex-shrink-0" }
const _hoisted_6 = {
  key: 1,
  class: "flex items-center flex-nowrap"
}
const _hoisted_7 = { class: "truncate font-semibold" }
const _hoisted_8 = { class: "mx-2 px-2 bg-gray-lp-200 font-medium whitespace-nowrap flex-shrink-0 rounded-lg" }
const _hoisted_9 = { class: "justify-self-end text-gray-lp-600 whitespace-nowrap flex-grow text-right my-2 text-14px" }
const _hoisted_10 = { class: "text-justify w-full my-4 text-14px" }
const _hoisted_11 = {
  key: 0,
  class: "flex flex-col gap-y-4 w-full"
}
const _hoisted_12 = {
  key: 1,
  class: "flex flex-col gap-y-4 w-full"
}
const _hoisted_13 = { class: "text-gray-lp-600 text-14px" }
const _hoisted_14 = { class: "flex gap-x-2" }
const _hoisted_15 = {
  key: 2,
  class: "flex flex-col gap-y-4 w-full mt-2"
}
const _hoisted_16 = {
  key: 3,
  class: "flex flex-col gap-y-4 w-full mt-2"
}
const _hoisted_17 = { class: "text-gray-lp-600 text-14px" }
const _hoisted_18 = { class: "font-semibold text-gray-lp-300" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "text-red-lp-500" }, "*", -1)
const _hoisted_20 = { class: "flex flex-row items-center gap-2" }
const _hoisted_21 = { class: "flex flex-col font-semibold gap-0" }
const _hoisted_22 = { class: "flex flex-row justify-between items-center" }
const _hoisted_23 = { class: "flex flex-row gap-3" }
const _hoisted_24 = { class: "flex flex-col gap-0 items-center" }
const _hoisted_25 = { class: "text-xs" }
const _hoisted_26 = { class: "flex flex-col gap-0 items-center" }
const _hoisted_27 = { class: "text-xs" }
const _hoisted_28 = { class: "flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DownloadAttachment = _resolveComponent("DownloadAttachment")!
  const _component_ImagePreviewForum = _resolveComponent("ImagePreviewForum")!
  const _component_FilePreviewForum = _resolveComponent("FilePreviewForum")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_UploadFileForum = _resolveComponent("UploadFileForum")!
  const _component_data_wrapper = _resolveComponent("data-wrapper")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_ImagePreview = _resolveComponent("ImagePreview")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.data, (data) => {
        return (_openBlock(), _createBlock("div", { key: data }, [
          _createVNode("div", {
            class: data.dfUpdatedActorRole === 'pos' ? `flex flex-row justify-end` :  `flex flex-row justify-start`
          }, [
            _createVNode("div", {
              class: data.dfUpdatedActorRole === 'pos' ? `bg-white py-4 px-8 rounded-2xl w-fit max-w-lg mx-8 my-8` : `bg-gray-lp-1000 py-4 px-8 rounded-2xl w-fit max-w-lg mx-8 my-4`
            }, [
              _createVNode("div", _hoisted_2, [
                (data.dfUpdatedActorRole === 'pos')
                  ? (_openBlock(), _createBlock("div", _hoisted_3, [
                      _createVNode("span", _hoisted_4, _toDisplayString(data.dfCreatedName.substring(0, 20)) + ".. - ", 1),
                      _createVNode("div", _hoisted_5, _toDisplayString(data.dfCreatedActorName.substring(0, 20)) + ".. ", 1)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_6, [
                      _createVNode("span", _hoisted_7, _toDisplayString(data.dfCreatedName.substring(0, 20)) + "..", 1),
                      _createVNode("div", _hoisted_8, _toDisplayString(data.dfCreatedActorName.substring(0, 20)) + ".. ", 1)
                    ]))
              ]),
              _createVNode("span", _hoisted_9, _toDisplayString(_ctx.formatDate(data.dfCreatedAt)), 1),
              _createVNode("div", _hoisted_10, _toDisplayString(data.dfDescription), 1),
              (data.dfImageFiles.every(value => value === ''))
                ? (_openBlock(), _createBlock("div", _hoisted_11))
                : (_openBlock(), _createBlock("div", _hoisted_12, [
                    _createVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('pusatResolusi.create.photoProof')), 1),
                    _createVNode("div", _hoisted_14, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(data.dfImageFiles, (image) => {
                        return (_openBlock(), _createBlock("div", { key: image }, [
                          image
                            ? (_openBlock(), _createBlock("img", {
                                key: 0,
                                alt: image,
                                src: image,
                                class: "rounded-xl cursor-pointer object-cover",
                                style: {"width":"60px","height":"60px"},
                                onClick: () => _ctx.onPreview(image)
                              }, null, 8, ["alt", "src", "onClick"]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ])),
              (data.dfAttachment.every(value => value === ''))
                ? (_openBlock(), _createBlock("div", _hoisted_15))
                : (_openBlock(), _createBlock("div", _hoisted_16, [
                    _createVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('pusatResolusi.history.attachment')), 1),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(data.dfAttachment, (file, index) => {
                      return (_openBlock(), _createBlock("div", {
                        key: index,
                        class: ""
                      }, [
                        file
                          ? (_openBlock(), _createBlock(_component_DownloadAttachment, {
                              key: 0,
                              name: `${_ctx.$t('pusatResolusi.history.attachment')} ${index + 1}`,
                              url: file,
                              maxLength: 25,
                              dash: false,
                              linked: ""
                            }, null, 8, ["name", "url"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
            ], 2)
          ], 2)
        ]))
      }), 128)),
      (!_ctx.isSolved && _ctx.isActorId)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class:  _ctx.data.data.length > 0 ? 'bg-white flex flex-col w-full gap-y-6 p-8': 'bg-gray-lp-1100 flex flex-col w-full gap-y-6 p-8'
          }, [
            _createVNode("div", _hoisted_18, [
              _createTextVNode(_toDisplayString(_ctx.$t('pusatResolusi.replyMessage')) + " ", 1),
              _hoisted_19
            ]),
            _createVNode(_component_LpInput, {
              type: "textarea",
              placeholder: _ctx.$t('pusatResolusi.create.writeUrReply'),
              modelValue: _ctx.form.message,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.message = $event)),
              maxLength: 1000,
              textAreaRows: _ctx.rows,
              class: "h-fit",
              resizableTextarea: true,
              showMaxLength: ""
            }, {
              "footer-textarea": _withCtx(() => [
                _createVNode("div", _hoisted_20, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.imgName, (item, index) => {
                    return (_openBlock(), _createBlock("div", { key: index }, [
                      _createVNode(_component_ImagePreviewForum, {
                        modelValue: _ctx.imgName,
                        onClick: ($event: any) => (_ctx.deleteImage(item)),
                        image: item
                      }, null, 8, ["modelValue", "onClick", "image"])
                    ]))
                  }), 128)),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fileName, (item, index) => {
                    return (_openBlock(), _createBlock("div", { key: index }, [
                      _createVNode(_component_FilePreviewForum, {
                        modelValue: _ctx.fileName,
                        onClick: ($event: any) => (_ctx.deleteFile(item)),
                        fileName: item
                      }, null, 8, ["modelValue", "onClick", "fileName"])
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["placeholder", "modelValue", "textAreaRows"]),
            _createVNode("div", _hoisted_21, [
              _createVNode("p", {
                class: _ctx.errImg ? `text-12px text-red-lp-500` : `text-12px text-gray-lp-600`
              }, _toDisplayString(_ctx.$t('pusatResolusi.maxSize')) + " " + _toDisplayString(_ctx.maxFileImg) + " " + _toDisplayString(_ctx.$t('pusatResolusi.eachSize')) + " " + _toDisplayString(_ctx.maxSize) + "MB ", 3),
              _createVNode("p", {
                class: _ctx.errFile ? `text-12px text-red-lp-500` : `text-12px text-gray-lp-600`
              }, _toDisplayString(_ctx.$t('pusatResolusi.maxSize')) + " " + _toDisplayString(_ctx.maxFileAttach) + " " + _toDisplayString(_ctx.$t('pusatResolusi.eachSize')) + " " + _toDisplayString(_ctx.maxSizeFile) + "MB ", 3)
            ]),
            _createVNode("div", _hoisted_22, [
              _createVNode(_component_data_wrapper, {
                label: _ctx.$t('pusatResolusi.addAttachment'),
                optional: ""
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_23, [
                    _createVNode("div", _hoisted_24, [
                      _createVNode(_component_UploadFileForum, {
                        allowed: "image/png, image/jpg, image/jpeg",
                        name: "Foto",
                        onChange: _ctx.convertImage,
                        maxRows: 100000
                      }, null, 8, ["onChange"]),
                      _createVNode("span", _hoisted_25, _toDisplayString(_ctx.imgName.length) + "/" + _toDisplayString(_ctx.maxFileImg), 1)
                    ]),
                    _createVNode("div", _hoisted_26, [
                      _createVNode(_component_UploadFileForum, {
                        allowed: ".pdf,.doc,.docx,.xls,.xlsx",
                        onChange: _ctx.convertFile,
                        name: "File",
                        maxRows: 100000
                      }, null, 8, ["onChange"]),
                      _createVNode("span", _hoisted_27, _toDisplayString(_ctx.fileName.length) + "/" + _toDisplayString(_ctx.maxFileAttach), 1)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode("div", _hoisted_28, [
                _createVNode(_component_lp_button, {
                  title: _ctx.$t('pusatResolusi.review.submit'),
                  textColor: "white",
                  disabled: !_ctx.form.message.length,
                  onClick: _cache[2] || (_cache[2] = () => _ctx.onSubmit(_ctx.data))
                }, null, 8, ["title", "disabled"])
              ])
            ])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ImagePreview, {
      modelValue: _ctx.imagePreview,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.imagePreview = $event)),
      data: _ctx.imagePreviews,
      image: _ctx.image
    }, null, 8, ["modelValue", "data", "image"])
  ], 64))
}